import { useState, useEffect, useRef, EffectCallback, DependencyList } from 'react'
import { dateParser } from '../utils/date-utils'

export function useOnlyUpdateableEffect(effect: EffectCallback, deps?: DependencyList): void {
  const isInitialMount = useRef(true)

  /* eslint-disable */
  useEffect(() => {
    if (isInitialMount.current) {
      isInitialMount.current = false
    } else {
      effect()
    }
  }, deps)
  /* eslint-enable */
}

export const useStateWithSessionStorage = <T>(
  localStorageKey: string,
  defaultValue: T
): [T, React.Dispatch<React.SetStateAction<T>>] => {
  const [value, setValue] = useState<T>(
    (() => {
      try {
        const s = sessionStorage.getItem(localStorageKey) || ''
        return JSON.parse(s, dateParser) as T
      } catch {
        return defaultValue
      }
    })()
  )

  useEffect(() => {
    sessionStorage.setItem(localStorageKey, JSON.stringify(value))
  }, [value, localStorageKey])

  return [value, setValue]
}

export function useWindowSize() {
  const [size, setSize] = useState([0, 0])
  useEffect(() => {
    function updateSize() {
      setSize([window.innerWidth, window.innerHeight])
    }
    window.addEventListener('resize', updateSize)
    updateSize()
    return () => window.removeEventListener('resize', updateSize)
  }, [])
  return size
}
